module.exports = __webpack_public_path__ + "img/match-card-bg.fbc3f3d.png";